export const environment = {
  production: false,
  googleMapsApiKey: '',
};
